import React, { useState } from 'react';

const PriceCalculator = () => {
    const [data, setData] = useState({
        traditionalPhotographyShifts: 0,
        traditionalVideographyShifts: 0,
        candidPhotographyShifts: 0,
        cinematographerShifts: 0,
        droneoperatorShift: 0,
        albumSheets: 0,
        profitMargin: 0,
    });

    const prices = {
        traditionalPhotographyPrice: 4000,
        traditionalVideographyPrice: 4000,
        candidPhotographyPrice: 6000,
        cinematographerPrice: 8000,
        droneOperatorPrice: 7000,
        albumPrices: {
            5: 4000, 10: 6000, 15: 8000, 20: 10000, 25: 12000, 30: 15000,
            35: 17000, 40: 20000, 45: 22000, 50: 25000
        }
    };

    const handleShiftChange = (type, value) => {
        setData((prev) => ({
            ...prev,
            [type]: Number(value)
        }));
    };

    const calculatePrice = (shifts, pricePerShift) => shifts * pricePerShift;
    const calculateAlbumPrice = (sheets) => prices.albumPrices[sheets] || 0;

    const totalPrice = (
        calculatePrice(data.traditionalPhotographyShifts, prices.traditionalPhotographyPrice) +
        calculatePrice(data.traditionalVideographyShifts, prices.traditionalVideographyPrice) +
        calculatePrice(data.candidPhotographyShifts, prices.candidPhotographyPrice) +
        calculatePrice(data.cinematographerShifts, prices.cinematographerPrice) +
        calculatePrice(data.droneoperatorShift, prices.droneOperatorPrice) +
        calculateAlbumPrice(data.albumSheets)
    );

    const profitAmount = Math.round((totalPrice * data.profitMargin) / 100);

    return (
        <>
            <header style={{ width: "100%", height: "auto" }}>
                <div
                    style={{
                        width: "100%",
                        height: "400px",
                        backgroundImage: "url('assets/images/Bulk/calculator.jpg')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                ></div>
            </header>

            <div className="container">
                <div style={{ padding: '40px 20px', maxWidth: '90%', width: '100%', margin: 'auto' }}>
                    <h1 style={{ textAlign: 'center', color: "black", fontSize: "32px", fontWeight: "bold", marginTop: "40px" }}>Event Price Calculator</h1>
                    <p style={{ fontSize: '18px', fontWeight: 'bold', color: 'red', textAlign: 'center', paddingTop: "20px", paddingBottom: "20px" }}>
                        Note: 1 Shift will be of 8 hours only.
                    </p>

                    {[
                        { label: 'Traditional Photographer Shifts', key: 'traditionalPhotographyShifts', price: prices.traditionalPhotographyPrice },
                        { label: 'Traditional Videographer Shifts', key: 'traditionalVideographyShifts', price: prices.traditionalVideographyPrice },
                        { label: 'Candid Photographer Shifts', key: 'candidPhotographyShifts', price: prices.candidPhotographyPrice },
                        { label: 'Cinematic Cinematographer Shifts', key: 'cinematographerShifts', price: prices.cinematographerPrice },
                        { label: 'Drone Operator Shifts', key: 'droneoperatorShift', price: prices.droneOperatorPrice }
                    ].map((item, index) => (
                        <div key={index} style={{
                            background: '#333',
                            padding: '20px',
                            borderRadius: '10px',
                            marginBottom: '15px',
                            color: 'white'
                        }}>
                            <label>{item.label}:</label>

                            <input
                                type="range"
                                min="0"
                                max="8"
                                step="1"
                                value={data[item.key]}
                                onChange={(e) => handleShiftChange(item.key, e.target.value)}
                                style={{ width: '100%', margin: '10px 0' }}
                            />

                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                fontSize: '14px',
                                gap: '4px',
                                textAlign: 'center'
                            }}>
                                {[...Array(9).keys()].map((num) => (
                                    <span key={num} style={{ minWidth: '24px' }}>{num}</span>
                                ))}
                            </div>

                            <div style={{ background: 'gainsboro', padding: '10px', borderRadius: '10px', marginTop: '10px' }}>
                                <h5 style={{ fontWeight: 'bold' }}>{item.label} Price</h5>
                                <h3 style={{ fontWeight: 'bold' }}>{calculatePrice(data[item.key], item.price)} RS</h3>
                            </div>
                        </div>
                    ))}

                    <div style={{
                        background: '#333',
                        padding: '20px',
                        borderRadius: '10px',
                        marginBottom: '15px',
                        color: 'white'
                    }}>
                        <label>Album Sheets:</label>

                        <input
                            type="range"
                            min="0"
                            max="50"
                            step="5"
                            value={data.albumSheets}
                            onChange={(e) => handleShiftChange('albumSheets', e.target.value)}
                            style={{ width: '100%', margin: '10px 0' }}
                        />

                        <div style={{ position: 'relative', width: '100%', height: '20px' }}>
                            {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50].map((num, index) => (
                                <span
                                    key={index}
                                    style={{
                                        position: 'absolute',
                                        left: `${(index / 10) * 100}%`,
                                        transform: 'translateX(-50%)',
                                        fontSize: '12px'
                                    }}
                                >
                                    {num}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div style={{ background: 'gainsboro', padding: '10px', borderRadius: '10px', marginBottom: '20px' }}>
                        <h5 style={{ fontWeight: 'bold' }}>Album Price</h5>
                        <h3 style={{ fontWeight: 'bold' }}>{calculateAlbumPrice(data.albumSheets)} RS</h3>
                    </div>


                    <div style={{
                        background: '#333',
                        padding: '20px',
                        borderRadius: '10px',
                        marginBottom: '15px',
                        color: 'white'
                    }}>
                        <label>Profit Margin (%):</label>

                        <input
                            type="range"
                            min="0"
                            max="40"
                            step="5"
                            value={data.profitMargin}
                            onChange={(e) => handleShiftChange('profitMargin', e.target.value)}
                            style={{ width: '100%', margin: '10px 0' }}
                        />

                        <div style={{ position: 'relative', width: '100%', height: '20px' }}>
                            {[0, 5, 10, 15, 20, 25, 30, 35, 40].map((num, index) => (
                                <span
                                    key={index}
                                    style={{
                                        position: 'absolute',
                                        left: `${(index / 8) * 100}%`,
                                        transform: 'translateX(-50%)',
                                        fontSize: '12px'
                                    }}
                                >
                                    {num}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div style={{ background: 'gainsboro', padding: '10px', borderRadius: '10px', marginBottom: '20px' }}>
                        <h5 style={{ fontWeight: 'bold' }}>Profit Amount</h5>
                        <h3 style={{ fontWeight: 'bold' }}>{profitAmount} RS</h3>
                    </div>


                    <div style={{
                        background: '#222',
                        padding: '20px',
                        borderRadius: '10px',
                        color: 'white',
                        textAlign: 'center'
                    }}>
                        <h3>Total Price</h3>
                        <h2 style={{ fontWeight: 'bold', color: 'gainsboro' }}>{totalPrice + profitAmount} RS</h2>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PriceCalculator;
